export default {
  'pages.login.failure': '登录失败，请重试！',
  'pages.login.callbackError': '回调异常',
  'pages.login.success': '登录成功！',
  'pages.login.azureButton': 'Azure AD 登录',
  'pages.logout.success': '已退出登录',
  'pages.logout.failure': '退出登录失败',
  'pages.404.subTitle': '抱歉，您访问的页面不存在。',
  'pages.404.buttonText': '返回首页',
};
